export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17" fill="none">
            <path
                d="M2.9302 5.10173L13.243 0.910015C13.7586 0.700433 14.3462 0.952201 14.5501 1.47011L15.9797 5.10173M6.52917 9.39227H9.2302M6.52917 12.1355H12.8302M18.6797 7.84499V6.10173C18.6797 5.54945 18.232 5.10173 17.6797 5.10173H1.67969C1.1274 5.10173 0.679688 5.54945 0.679688 6.10173V7.84499C2.02917 7.84499 3.37969 8.75906 3.37969 10.5882C3.37969 12.4174 2.0302 13.3315 0.679688 13.3315V15.0747C0.679688 15.627 1.1274 16.0747 1.67969 16.0747H17.6797C18.232 16.0747 18.6797 15.627 18.6797 15.0747V13.3315C17.3302 13.3315 15.9797 11.9593 15.9797 10.3592C15.9797 8.75906 17.3302 7.84499 18.6797 7.84499Z"
                stroke="url(#paint0_linear_567_7040)"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <defs>
                <linearGradient id="paint0_linear_567_7040" x1="17.6797" y1="4.94922" x2="3.67969" y2="15.4492" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FBD997" />
                    <stop offset="0.625003" stopColor="#CC9856" />
                    <stop offset="1" stopColor="#C28A48" />
                </linearGradient>
            </defs>
        </svg>
    );
}
